export const styles = {
  backdrop: {
    position: 'absolute',
    inset: 0,
    zIndex: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 24px calc(env(safe-area-inset-bottom, 0px) + 96px)',
    // Deep-ocean tint — matches the stylized globe's water
    background: 'radial-gradient(ellipse at 50% 30%, rgba(10, 52, 96, 0.60), rgba(4, 26, 52, 0.82))',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    animation: 'orboot-fade-in 240ms ease-out',
  },
  backdropMobile: {
    alignItems: 'stretch',
    padding: '8px 8px calc(env(safe-area-inset-bottom, 0px) + 76px)',
  },
  stage: {
    position: 'relative',
    width: 'min(1100px, 100%)',
    minHeight: '70vh',
    maxHeight: 'calc(100vh - 110px)',
    overflow: 'auto',
    borderRadius: 32,
    border: '4px solid rgba(255, 255, 255, 0.92)',
    boxShadow: '0 40px 80px rgba(4, 26, 52, 0.50), inset 0 0 0 1px rgba(29, 115, 194, 0.08)',
    // Sky + land palette pulled from the stylized globe (ocean #1D73C2, green #57B04A, sand #F2C770)
    background: `
      radial-gradient(circle at 14% 92%, rgba(87, 176, 74, 0.16), transparent 22%),
      radial-gradient(circle at 86% 13%, rgba(29, 115, 194, 0.12), transparent 24%),
      linear-gradient(180deg, #F0F9FF 0%, #FDFEFB 55%, #FFF9EC 100%)
    `,
    padding: '24px clamp(20px, 4vw, 48px) 30px',
    color: '#0f172a',
  },
  stageMobile: {
    width: '100%',
    minHeight: 'auto',
    maxHeight: 'calc(100dvh - 84px)',
    borderRadius: 20,
    padding: '14px 12px 20px',
  },
  closeBtn: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 4,
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: '1px solid rgba(15, 23, 42, 0.08)',
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    color: '#334155',
    display: 'grid',
    placeItems: 'center',
    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)',
    cursor: 'pointer',
    transition: 'background 150ms var(--ease-out)',
  },
  doodles: {
    position: 'absolute',
    inset: 20,
    pointerEvents: 'none',
    display: 'none', // removed — replaced by cleaner accent on hero
  },
  step: {
    position: 'relative',
    minHeight: 'auto',
    isolation: 'isolate',
  },
  stepMobile: {
    minHeight: 'auto',
  },
  heroGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(330px, 0.96fr) minmax(320px, 1.04fr)',
    alignItems: 'center',
    gap: 42,
    position: 'relative',
    zIndex: 1,
    paddingBottom: '3%',
  },
  heroGridMobile: {
    gridTemplateColumns: '1fr',
    gap: 4,
    paddingTop: 4,
    paddingBottom: 0,
  },
  welcomeVisualStack: {
    justifySelf: 'center',
    width: 'min(340px, 100%)',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    alignItems: 'end',
    justifyItems: 'center',
    gap: 0,
    transform: 'rotate(-4deg)',
  },
  welcomeVisualStackMobile: {
    width: 'min(220px, 100%)',
    gridTemplateRows: 'auto auto',
    gap: 0,
    transform: 'none',
    order: 2,
  },
  bearySlot: {
    justifySelf: 'center',
    alignSelf: 'end',
    marginTop: -130,
    marginLeft: 100,
    position: 'relative',
    zIndex: 3,
    transform: 'rotate(3deg)',
  },
  bearySlotMobile: {
    alignSelf: 'center',
    marginTop: -120,
    marginLeft: 36,
  },
  artifactSlot: {
    justifySelf: 'center',
    width: 'min(290px, 100%)',
    height: 280,
    borderRadius: 999,
    background: 'radial-gradient(circle, rgba(251, 191, 36, 0.14), rgba(251, 191, 36, 0.04) 60%, rgba(255,255,255,0) 75%)',
  },
  mapBadge: {
    position: 'relative',
    width: 'min(340px, 100%)',
    aspectRatio: '1054 / 1492',
    background: 'url("/passport-page-vertical-alpha.png") center / contain no-repeat',
    border: 'none',
    boxShadow: 'none',
    filter: 'drop-shadow(10px 18px 18px rgba(120, 53, 15, 0.22))',
    padding: 0,
    display: 'block',
    overflow: 'visible',
  },
  mapBadgeMobile: {
    width: 'min(220px, 100%)',
  },
  mapBadgeHeader: {
    position: 'absolute',
    left: '10%',
    top: '6.4%',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    zIndex: 4,
  },
  mapBadgeTitle: {
    color: '#111827',
    fontSize: 18,
    fontWeight: 800,
    lineHeight: 1.15,
    letterSpacing: '-0.035em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textShadow: '0 1px 0 rgba(255,255,255,0.75)',
  },
  passportSlots: {
    position: 'absolute',
    left: '9%',
    top: '9%',
    width: '82%',
    height: '84%',
    display: 'grid',
    gridTemplateRows: 'minmax(0, 1fr) 26px minmax(0, 1fr)',
    gap: 0,
    padding: '0 1.4%',
    borderRadius: 18,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    zIndex: 1,
  },
  passportDivider: {
    height: 26,
    width: '100%',
    justifySelf: 'center',
    background: 'transparent',
    boxShadow: 'none',
  },
  passportSlotLabel: {
    position: 'absolute',
    left: 14,
    top: 12,
    color: 'rgba(146, 64, 14, 0.22)',
    fontSize: 11,
    fontWeight: 900,
    textTransform: 'uppercase',
    letterSpacing: '0.14em',
    zIndex: 2,
  },
  mapFlag: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    objectFit: 'cover',
    display: 'block',
    boxShadow: '0 0 0 3px #fff, 0 4px 12px rgba(15, 23, 42, 0.12)',
    flex: '0 0 auto',
  },
  mapFlagFallback: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    fontSize: 24,
    boxShadow: '0 0 0 3px #fff, 0 4px 12px rgba(15, 23, 42, 0.12)',
    flex: '0 0 auto',
  },
  mapFrame: {
    position: 'relative',
    height: 'auto',
    minHeight: 0,
    borderRadius: 16,
    background: `
      radial-gradient(circle at 32% 22%, rgba(255,255,255,0.76), transparent 24%),
      linear-gradient(135deg, rgba(255, 237, 213, 0.82), rgba(254, 249, 195, 0.6))
    `,
    display: 'grid',
    placeItems: 'center',
    overflow: 'hidden',
    border: '1px solid rgba(180, 83, 9, 0.08)',
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.38), inset 0 -20px 40px rgba(255, 247, 237, 0.24)',
  },
  mapFrameMobile: {
    borderRadius: 14,
  },
  mapSvg: {
    width: '70%',
    height: '74%',
    display: 'block',
    filter: 'drop-shadow(0 12px 14px rgba(146, 64, 14, 0.22)) saturate(1.15)',
  },
  mapSkeleton: {
    width: '72%',
    height: '58%',
    display: 'grid',
    placeItems: 'center',
    gap: 12,
    opacity: 0.36,
  },
  mapSkeletonBlob: {
    width: '72%',
    height: 70,
    borderRadius: '44% 56% 52% 48%',
  },
  mapSkeletonLine: {
    width: '54%',
    height: 10,
    borderRadius: 999,
  },
  mapFallback: {
    display: 'grid',
    placeItems: 'center',
    gap: 10,
    color: '#0f172a',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'center',
    padding: 18,
    letterSpacing: '-0.005em',
  },
  mapFallbackFlag: {
    width: 80,
    height: 60,
    borderRadius: 10,
    objectFit: 'cover',
    display: 'block',
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.14)',
  },
  mapFallbackEmoji: {
    width: 80,
    height: 60,
    borderRadius: 10,
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    fontSize: 40,
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.14)',
  },
  storyImageFrame: {
    position: 'relative',
    height: 'auto',
    minHeight: 0,
    borderRadius: 16,
    background: '#fffaf0',
    padding: 7,
    overflow: 'hidden',
    border: '1px solid rgba(180, 83, 9, 0.12)',
    boxShadow: '0 8px 16px rgba(120, 53, 15, 0.12), inset 0 0 0 1px rgba(255,255,255,0.72)',
    zIndex: 1,
  },
  storyImageFrameMobile: {
    borderRadius: 12,
  },
  storyImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    borderRadius: 13,
    background: '#fff7ed',
  },
  storyImageFallback: {
    width: '100%',
    height: '100%',
    borderRadius: 13,
    display: 'grid',
    placeItems: 'center',
    gap: 6,
    color: '#92400e',
    fontWeight: 800,
    background: 'linear-gradient(135deg, #fef3c7, #fed7aa)',
  },
  storyFallbackFlag: {
    width: 66,
    height: 48,
    objectFit: 'cover',
    borderRadius: 9,
    boxShadow: '0 6px 16px rgba(120, 53, 15, 0.18)',
  },
  storyFallbackEmoji: {
    fontSize: 36,
  },
  firstStopStamp: {
    position: 'absolute',
    left: 18,
    bottom: 10,
    width: 102,
    height: 58,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    gap: 0,
    textAlign: 'center',
    transform: 'rotate(-8deg)',
    background: 'rgba(255, 247, 237, 0.92)',
    border: '2px solid rgba(180, 83, 9, 0.52)',
    color: '#9a3412',
    textTransform: 'uppercase',
    boxShadow: '0 4px 10px rgba(120, 53, 15, 0.16)',
    fontSize: 11,
    lineHeight: 1,
    letterSpacing: '0.04em',
  },
  photoCornerTopLeft: {
    position: 'absolute',
    left: 3,
    top: 3,
    width: 25,
    height: 25,
    borderTop: '4px solid rgba(255, 255, 255, 0.9)',
    borderLeft: '4px solid rgba(255, 255, 255, 0.9)',
    borderRadius: '9px 0 0 0',
    zIndex: 2,
  },
  photoCornerTopRight: {
    position: 'absolute',
    right: 3,
    top: 3,
    width: 25,
    height: 25,
    borderTop: '4px solid rgba(255, 255, 255, 0.9)',
    borderRight: '4px solid rgba(255, 255, 255, 0.9)',
    borderRadius: '0 9px 0 0',
    zIndex: 2,
  },
  photoCornerBottomLeft: {
    position: 'absolute',
    left: 3,
    bottom: 3,
    width: 25,
    height: 25,
    borderBottom: '4px solid rgba(255, 255, 255, 0.9)',
    borderLeft: '4px solid rgba(255, 255, 255, 0.9)',
    borderRadius: '0 0 0 9px',
    zIndex: 2,
  },
  photoCornerBottomRight: {
    position: 'absolute',
    right: 3,
    bottom: 3,
    width: 25,
    height: 25,
    borderBottom: '4px solid rgba(255, 255, 255, 0.9)',
    borderRight: '4px solid rgba(255, 255, 255, 0.9)',
    borderRadius: '0 0 9px 0',
    zIndex: 2,
  },
  passportPaperGlow: {
    position: 'absolute',
    inset: '7.4% 51.5% 7.4% 5.3%',
    borderRadius: 18,
    border: '1px dashed rgba(146, 64, 14, 0.16)',
    pointerEvents: 'none',
    display: 'none',
  },
  passportStamp: {
    position: 'absolute',
    right: 28,
    top: 14,
    width: 78,
    height: 78,
    borderRadius: '50%',
    display: 'none',
    placeItems: 'center',
    color: 'rgba(146, 64, 14, 0.18)',
    border: '3px double rgba(146, 64, 14, 0.14)',
    fontSize: 16,
    fontWeight: 900,
    transform: 'rotate(10deg)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  mapDoodleOne: {
    position: 'absolute',
    left: 32,
    bottom: 26,
    width: 34,
    height: 34,
    opacity: 0.28,
    borderLeft: '2px solid #92400e',
    borderBottom: '2px solid #92400e',
    transform: 'rotate(-24deg)',
  },
  mapDoodleTwo: {
    position: 'absolute',
    right: 42,
    top: 60,
    width: 52,
    height: 18,
    opacity: 0.22,
    borderTop: '2px dashed #92400e',
    borderRadius: '50%',
  },
  centerCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 16,
    position: 'relative',
    zIndex: 2,
  },
  centerCopyMobile: {
    gap: 11,
  },
  titleFlagWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    maxWidth: '100%',
    position: 'relative',
  },
  titleFlag: {
    width: 80,
    height: 60,
    borderRadius: 10,
    objectFit: 'cover',
    display: 'block',
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.18), 0 0 0 3px #fff',
  },
  titleFlagFallback: {
    width: 80,
    height: 60,
    borderRadius: 10,
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    fontSize: 40,
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.18), 0 0 0 3px #fff',
  },
  progressDots: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    padding: '2px 0',
  },
  progressDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    flexShrink: 0,
    transition: 'transform 200ms var(--ease-out), background 200ms var(--ease-out)',
  },
  stepPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 9,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'currentColor',
    borderRadius: 999,
    background: 'rgba(255, 253, 247, 0.78)',
    padding: '7px 18px 7px 9px',
    fontSize: 15,
    fontWeight: 900,
    margin: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    boxShadow: '0 6px 16px rgba(120, 53, 15, 0.08)',
  },
  welcomeDecor: {
    position: 'absolute',
    inset: -30,
    pointerEvents: 'none',
    zIndex: 0,
    overflow: 'hidden',
    borderRadius: 26,
  },
  decorLeafTop: {
    display: 'none', // superseded by WizardScenery 3D layers
    position: 'absolute',
    top: -8,
    left: -8,
    width: 122,
    height: 84,
    background: 'radial-gradient(circle at 20% 80%, #166534 0 16px, transparent 17px), radial-gradient(circle at 44% 48%, #15803d 0 20px, transparent 21px), radial-gradient(circle at 72% 22%, #84cc16 0 15px, transparent 16px)',
    filter: 'drop-shadow(0 8px 14px rgba(22, 101, 52, 0.18))',
    opacity: 0.88,
  },
  decorFeather: {
    display: 'none', // superseded by WizardScenery 3D layers
    position: 'absolute',
    left: 10,
    bottom: 58,
    width: 92,
    height: 150,
    borderRadius: '70% 25% 70% 25%',
    background: 'radial-gradient(circle at 56% 28%, #1d4ed8 0 8px, #0f766e 9px 16px, #f59e0b 17px 23px, transparent 24px), linear-gradient(155deg, transparent 0 38%, #16a34a 39% 42%, transparent 43%), linear-gradient(135deg, rgba(34,197,94,0.85), rgba(20,184,166,0.2) 54%, transparent 55%)',
    transform: 'rotate(18deg)',
    opacity: 0.9,
  },
  decorLamp: {
    display: 'none', // superseded by WizardScenery 3D layers
    position: 'absolute',
    left: 30,
    bottom: 20,
    width: 74,
    height: 38,
    borderRadius: '0 0 42px 42px',
    background: 'radial-gradient(circle at 50% -18%, #fde68a 0 13px, transparent 14px), radial-gradient(ellipse at 50% 0%, rgba(255, 237, 170, 0.75), transparent 36%), linear-gradient(180deg, #f59e0b, #9a3412)',
    boxShadow: '0 0 20px rgba(251, 191, 36, 0.42)',
    opacity: 0.72,
  },
  decorPlant: {
    display: 'none', // superseded by WizardScenery 3D layers
    position: 'absolute',
    right: 16,
    bottom: 4,
    width: 126,
    height: 116,
    background: `
      radial-gradient(ellipse at 18% 82%, #15803d 0 15px, transparent 16px),
      radial-gradient(ellipse at 46% 62%, #22c55e 0 25px, transparent 26px),
      radial-gradient(ellipse at 76% 78%, #166534 0 20px, transparent 21px),
      linear-gradient(100deg, transparent 0 44%, rgba(22, 101, 52, 0.55) 45% 48%, transparent 49%)
    `,
    clipPath: 'polygon(0 100%, 12% 55%, 28% 86%, 45% 30%, 58% 82%, 76% 48%, 100% 100%)',
    opacity: 0.68,
  },
  decorMonument: {
    display: 'none', // superseded by WizardScenery 3D layers
    position: 'absolute',
    right: 10,
    bottom: 40,
    width: 170,
    height: 170,
    opacity: 0.18,
    background: 'linear-gradient(90deg, transparent 0 18%, #d97706 19% 24%, transparent 25% 42%, #d97706 43% 58%, transparent 59% 76%, #d97706 77% 82%, transparent 83%), radial-gradient(circle at 50% 30%, #d97706 0 36px, transparent 37px)',
    clipPath: 'polygon(0 100%, 0 58%, 12% 58%, 12% 22%, 22% 22%, 22% 58%, 36% 58%, 38% 40%, 50% 16%, 62% 40%, 64% 58%, 78% 58%, 78% 22%, 88% 22%, 88% 58%, 100% 58%, 100% 100%)',
  },
  decorBalloon: {
    position: 'absolute',
    right: 62,
    top: 48,
    width: 76,
    height: 112,
    filter: 'drop-shadow(0 12px 18px rgba(120, 53, 15, 0.18))',
    animation: 'orboot-bob 3.8s ease-in-out infinite',
  },
  title: {
    margin: 0,
    display: 'grid',
    gap: 4,
    fontSize: 'clamp(40px, 5.2vw, 58px)',
    lineHeight: 0.95,
    color: '#07132b',
    letterSpacing: '-0.04em',
    fontWeight: 900,
    textShadow: '0 2px 0 rgba(255,255,255,0.8), 0 10px 24px rgba(15, 23, 42, 0.08)',
  },
  titleMobile: {
    fontSize: 30,
    lineHeight: 0.98,
    letterSpacing: '-0.025em',
  },
  titleCountry: {
    fontSize: '1.18em',
    display: 'block',
    letterSpacing: '-0.045em',
  },
  titleSparkLeft: {
    position: 'absolute',
    left: -54,
    bottom: 26,
    width: 34,
    height: 38,
    background: `
      linear-gradient(#22c55e, #22c55e) 0 4px / 7px 3px no-repeat,
      linear-gradient(#22c55e, #22c55e) 2px 2px / 3px 7px no-repeat,
      linear-gradient(#fb923c, #fb923c) 16px 18px / 18px 3px no-repeat,
      linear-gradient(35deg, transparent 0 45%, #fb923c 46% 54%, transparent 55%) 12px 23px / 20px 12px no-repeat
    `,
  },
  titleSparkRight: {
    position: 'absolute',
    right: -54,
    bottom: 24,
    width: 36,
    height: 42,
    background: `
      linear-gradient(#ef4444, #ef4444) 28px 0 / 3px 14px no-repeat,
      linear-gradient(#ef4444, #ef4444) 22px 6px / 14px 3px no-repeat,
      linear-gradient(#22c55e, #22c55e) 2px 28px / 7px 3px no-repeat,
      linear-gradient(#22c55e, #22c55e) 4px 26px / 3px 7px no-repeat,
      linear-gradient(145deg, transparent 0 45%, #fb923c 46% 54%, transparent 55%) 10px 18px / 20px 12px no-repeat
    `,
  },
  speechBubble: {
    position: 'relative',
    maxWidth: 390,
    background: 'rgba(255, 255, 255, 0.92)',
    border: '1px solid rgba(29, 115, 194, 0.16)',
    borderRadius: 20,
    padding: '14px 28px',
    color: '#1e293b',
    fontSize: 'clamp(16px, 1.4vw, 18px)',
    fontWeight: 700,
    lineHeight: 1.45,
    boxShadow: '0 8px 20px rgba(120, 53, 15, 0.08), inset 0 0 0 1px rgba(255,255,255,0.72)',
    letterSpacing: '-0.005em',
  },
  speechBubbleMobile: {
    borderRadius: 14,
    padding: '10px 14px',
    fontSize: 15,
  },
  bubbleTail: {
    position: 'absolute',
    left: -8,
    top: '50%',
    width: 14,
    height: 14,
    background: 'rgba(255, 255, 255, 0.92)',
    borderLeft: '1px solid rgba(29, 115, 194, 0.16)',
    borderBottom: '1px solid rgba(29, 115, 194, 0.16)',
    transform: 'translateY(-50%) rotate(45deg)',
  },
  bubbleNotchRight: {
    position: 'absolute',
    right: -8,
    top: '50%',
    width: 14,
    height: 14,
    background: 'rgba(255, 255, 255, 0.92)',
    borderRight: '1px solid rgba(29, 115, 194, 0.16)',
    borderTop: '1px solid rgba(29, 115, 194, 0.16)',
    transform: 'translateY(-50%) rotate(45deg)',
  },
  primaryBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    border: '3px solid #fff7ed',
    borderRadius: 22,
    color: '#ffffff',
    fontSize: 'clamp(19px, 2vw, 23px)',
    fontWeight: 900,
    padding: '15px 32px',
    boxShadow: '0 16px 30px rgba(234, 88, 12, 0.38), 0 5px 0 rgba(194, 65, 12, 0.22), inset 0 -3px 0 rgba(154, 52, 18, 0.22)',
    cursor: 'pointer',
    letterSpacing: '-0.02em',
    transition: 'transform 200ms cubic-bezier(0.34,1.56,0.64,1)',
    minWidth: 292,
  },
  primaryBtnMobile: {
    width: '100%',
    maxWidth: 292,
    fontSize: 15,
    padding: '11px 18px',
    minWidth: 0,
  },
  audioBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(14, 165, 233, 0.22)',
    borderRadius: 999,
    background: 'rgba(239, 246, 255, 0.82)',
    color: '#0369a1',
    fontSize: 15,
    fontWeight: 800,
    padding: '11px 18px',
    boxShadow: '0 3px 10px rgba(14, 116, 144, 0.08)',
    cursor: 'pointer',
    letterSpacing: '-0.005em',
    transition: 'background 150ms var(--ease-out)',
  },
  audioBtnActive: {
    background: '#dff3ff',
    borderColor: 'rgba(14, 165, 233, 0.38)',
    color: '#075985',
  },
  audioBtnSecondary: {
    paddingInline: 17,
  },
  audioControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    flexWrap: 'wrap',
  },
  audioBtnDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  ctaFlag: {
    width: 38,
    height: 26,
    borderRadius: 999,
    objectFit: 'cover',
    boxShadow: '0 0 0 2px rgba(255,255,255,0.72)',
  },
  ctaFlagFallback: {
    fontSize: 22,
  },
  stepCompass: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    boxShadow: '0 2px 8px rgba(120, 53, 15, 0.14)',
    marginLeft: -7,
  },
  stepFlag: {
    width: 22,
    height: 22,
    borderRadius: '50%',
    objectFit: 'cover',
  },
  stepFlagFallback: {
    fontSize: 16,
  },
  cardsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    marginBottom: 14,
  },
  cardsHeaderMobile: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: 10,
  },
  sectionTitle: {
    margin: '8px 0 0',
    color: '#0f172a',
    fontSize: 'clamp(24px, 3.4vw, 36px)',
    lineHeight: 1.08,
    letterSpacing: '-0.025em',
    fontWeight: 700,
  },
  sectionTitleMobile: {
    fontSize: 22,
  },
  progressBadge: {
    borderRadius: 999,
    background: '#f1f5f9',
    color: '#334155',
    padding: '7px 16px',
    fontWeight: 600,
    fontSize: 14,
    border: '1px solid rgba(15, 23, 42, 0.06)',
    whiteSpace: 'nowrap',
    letterSpacing: '-0.005em',
  },
  discoveryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 12,
  },
  discoveryGridMobile: {
    gridTemplateColumns: '1fr',
    gap: 10,
  },
  discoveryCard: {
    minHeight: 112,
    display: 'grid',
    gridTemplateColumns: '48px 1fr 34px',
    alignItems: 'center',
    gap: 14,
    padding: '14px 16px',
    borderRadius: 16,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#BFE0F5',
    textAlign: 'left',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
    cursor: 'pointer',
    touchAction: 'manipulation',
    WebkitTapHighlightColor: 'transparent',
    transition: 'box-shadow 200ms var(--ease-out)',
  },
  discoveryIcon: {
    width: 48,
    height: 48,
    borderRadius: 14,
    display: 'grid',
    placeItems: 'center',
    background: '#ffffff',
    fontSize: 24,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  },
  discoveryText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    minWidth: 0,
    color: '#334155',
    fontSize: 15,
    lineHeight: 1.4,
    letterSpacing: '-0.005em',
  },
  discoveryReveal: {
    display: 'grid',
    gap: 10,
    marginTop: 10,
  },
  discoveryImageFrame: {
    width: '100%',
    height: '22vh',
    maxHeight: 220,
    display: 'grid',
    placeItems: 'center',
    padding: 6,
    borderRadius: 14,
    background: 'rgba(255,255,255,0.95)',
    boxShadow: 'inset 0 0 0 1px rgba(15, 23, 42, 0.06)',
    overflow: 'hidden',
  },
  discoveryImageFrameMobile: {
    height: '18vh',
    maxHeight: 180,
  },
  discoveryImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 10,
    objectFit: 'contain',
    display: 'block',
  },
  discoveryDetail: {
    color: '#0f172a',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.5,
  },
  discoveryAudioBtn: {
    justifySelf: 'start',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(14, 165, 233, 0.22)',
    borderRadius: 999,
    background: 'rgba(239, 246, 255, 0.82)',
    color: '#0369a1',
    fontSize: 15,
    fontWeight: 800,
    padding: '11px 18px',
    boxShadow: '0 3px 10px rgba(14, 116, 144, 0.08)',
    cursor: 'pointer',
    letterSpacing: '-0.005em',
    transition: 'background 150ms var(--ease-out)',
  },
  discoveryAudioBtnActive: {
    background: '#dff3ff',
    borderColor: 'rgba(14, 165, 233, 0.38)',
    color: '#075985',
  },
  mediaLoading: {
    color: '#64748b',
    fontSize: 14,
    fontWeight: 500,
  },
  mediaError: {
    color: '#b91c1c',
    fontSize: 14,
    fontWeight: 500,
  },
  rewardDot: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    color: '#fff',
    fontSize: 14,
    fontWeight: 700,
  },
  stepFooter: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: 16,
    marginTop: 14,
    background: '#f8fafc',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    borderRadius: 16,
    padding: '10px 14px',
  },
  stepFooterMobile: {
    gridTemplateColumns: '1fr auto',
    padding: '10px 12px',
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    marginTop: 12,
  },
  footerHint: {
    margin: 0,
    color: '#334155',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '-0.005em',
    lineHeight: 1.4,
  },
  secondaryBtn: {
    border: 'none',
    borderRadius: 999,
    padding: '12px 24px',
    background: '#0f172a',
    color: '#ffffff',
    fontWeight: 700,
    fontSize: 16,
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.25)',
    cursor: 'pointer',
    letterSpacing: '-0.005em',
    transition: 'transform 150ms var(--ease-out)',
  },
  secondaryBtnDisabled: {
    background: '#e2e8f0',
    color: '#94a3b8',
    boxShadow: 'none',
    cursor: 'not-allowed',
  },
  secondaryBtnMobile: {
    justifySelf: 'end',
  },
  wonderLayout: {
    minHeight: 520,
    display: 'grid',
    gridTemplateColumns: 'minmax(280px, 0.8fr) minmax(360px, 1.2fr)',
    gridTemplateRows: '1fr auto',
    alignItems: 'center',
    gap: 22,
  },
  wonderLayoutMobile: {
    minHeight: 'auto',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
    gap: 14,
  },
  wonderCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 14,
  },
  wonderBubble: {
    position: 'relative',
    width: '100%',
    background: '#f8fafc',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    borderRadius: 18,
    padding: '16px 18px',
    color: '#0f172a',
    fontSize: 'clamp(18px, 2vw, 24px)',
    fontWeight: 700,
    lineHeight: 1.35,
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.07)',
  },
  wonderBubbleMobile: {
    fontSize: 17,
    padding: '14px 16px',
  },
  wonderVisual: {
    minHeight: 360,
    borderRadius: 24,
    background: 'linear-gradient(135deg, #f0f9ff 0%, #fff7ed 100%)',
    display: 'grid',
    placeItems: 'center',
    padding: 16,
    boxShadow: 'inset 0 0 0 1px rgba(15, 23, 42, 0.06), 0 18px 42px rgba(15, 23, 42, 0.12)',
    overflow: 'hidden',
  },
  wonderVisualMobile: {
    minHeight: 230,
    borderRadius: 18,
    padding: 10,
  },
  wonderImage: {
    width: '100%',
    height: '100%',
    maxHeight: 360,
    objectFit: 'contain',
    display: 'block',
    borderRadius: 16,
  },
  wonderLoading: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    background: '#ffffff',
    color: '#ca8a04',
    fontSize: 54,
    boxShadow: '0 12px 28px rgba(15, 23, 42, 0.10)',
    animation: 'orboot-bob 1.4s ease-in-out infinite',
  },
  wonderFooter: {
    gridColumn: '1 / -1',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: 16,
    padding: '12px 16px',
    borderRadius: 16,
    background: '#f8fafc',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    color: '#334155',
    fontSize: 15,
    fontWeight: 600,
  },
  wonderFooterMobile: {
    gridTemplateColumns: '1fr auto',
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    marginTop: 12,
  },
  quizLayout: {
    display: 'grid',
    gap: 20,
  },
  quizQuestion: {
    color: '#334155',
    fontSize: 17,
    fontWeight: 500,
    margin: '6px 0 0',
    letterSpacing: '-0.005em',
    lineHeight: 1.5,
  },
  quizOptions: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 12,
  },
  quizOptionsMobile: {
    gridTemplateColumns: '1fr',
    gap: 10,
  },
  quizOption: {
    minHeight: 170,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#BFE0F5',
    borderRadius: 18,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    padding: 14,
    color: '#0f172a',
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
    cursor: 'pointer',
    letterSpacing: '-0.005em',
  },
  quizOptionMobile: {
    minHeight: 76,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 14,
    borderRadius: 14,
    padding: 10,
  },
  quizIcon: {
    width: 72,
    height: 72,
    borderRadius: 18,
    display: 'grid',
    placeItems: 'center',
    background: '#ffffff',
    fontSize: 40,
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  },
  quizImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
  quizResult: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: 16,
    padding: '12px 16px',
    borderRadius: 16,
    background: '#f8fafc',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    color: '#334155',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: '-0.005em',
    lineHeight: 1.45,
  },
  quizResultMobile: {
    gridTemplateColumns: 'auto 1fr',
  },
  finishBtn: {
    fontSize: 16,
    padding: '12px 24px',
    boxShadow: '0 8px 20px rgba(251, 191, 36, 0.32)',
    minWidth: 0,
  },
  finishBtnMobile: {
    justifySelf: 'end',
    fontSize: 15,
    padding: '11px 20px',
    minWidth: 0,
  },
  rewardStep: {
    minHeight: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    gap: 12,
    padding: '40px 0 26px',
  },
  rewardStepMobile: {
    minHeight: 'auto',
    padding: '28px 0 18px',
    gap: 14,
  },
  badge: {
    width: 184,
    minHeight: 184,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#f59e0b',
    borderRadius: '50%',
    padding: '16px 22px',
    background: 'linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%)',
    color: '#78350f',
    boxShadow: '0 24px 48px rgba(251, 191, 36, 0.30), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
    letterSpacing: '-0.005em',
  },
  flagBadge: {
    width: 76,
    height: 76,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    fontSize: 44,
    lineHeight: 1,
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.14), inset 0 0 0 3px #fff',
    overflow: 'hidden',
  },
  flagImage: {
    width: 76,
    height: 76,
    objectFit: 'cover',
    display: 'block',
  },
  flagFallback: {
    fontSize: 44,
    lineHeight: 1,
  },
  rewardText: {
    maxWidth: 460,
    margin: 0,
    color: '#475569',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.55,
    letterSpacing: '-0.005em',
  },
};
